const GET_TENANTS_PENDING: string = 'GET_TENANTS_PENDING'
const GET_TENANTS_SUCCESS: string = 'GET_TENANTS_SUCCESS'
const GET_TENANTS_ERROR: string = 'GET_TENANTS_ERROR'
const GET_TENANTS_INIT: string = 'GET_TENANTS_INIT'

export { GET_TENANTS_PENDING, GET_TENANTS_SUCCESS, GET_TENANTS_ERROR, GET_TENANTS_INIT }
